<template>
    <div class="meeting_popup_scroll">
        <div class="create_ticket_popup">
            <div class="create_ticket_popup_center">
                <div class="create_ticket_popup_modal">
                    <div class="create_ticket_popup_header">
                        <h4>Create Ticket</h4>
                        <span class="create_ticket_popup_close">
                            <i class="fa fa-times" @click="closePopupOfTicketCreationMethod"></i>
                        </span>
                    </div>
                    <div class="create_ticket_popup_body">
                        <form @submit.prevent="createTicketBeforeSubmitMethod">
                            <div class="form-group">
                                <label>Title</label>
                                <input class="form-control" type="text" v-validate="'required'" v-model="title"
                                    name="title" v-bind:class="{ 'is-invalid': errors.has('title') }"
                                    data-vv-as="title" />
                                <small class="invalid-feedback" v-if="errors.has('title')">{{ errors.first('title')
                                    }}</small>
                            </div>
                            <div class="form-group">
                                <label>Topic</label>
                                <textarea class="form-control" rows="4" v-validate="'required'" v-model="message"
                                    name="message" v-bind:class="{ 'is-invalid': errors.has('message') }"
                                    data-vv-as="message"></textarea>
                                <small class="invalid-feedback" v-if="errors.has('message')">{{ errors.first('message')
                                    }}</small>
                            </div>
                            <div class="btn-group">
                                <button type="submit" class="btn btn-primary" :disabled="submitted">Create</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
/*eslint-disable */
import axios from 'axios';
const BaseURL = process.env.VUE_APP_API_BASE_URL;
import { bus } from '@/main';
import toast from '@/services/toast';

export default {
    name: 'create-ticket-info-popup',
    props: [],
    data() {
        return {
            title: "",
            message: "",
            submitted: false
        }
    },
    computed: {

    },
    mounted() {
        document.body.classList.add('body_right_scroll_remove');
    },
    methods: {
        createTicketBeforeSubmitMethod() {
            this.$validator.validateAll().then((result) => {
                if (result) {
                    this.submitted = true
                    let data = {
                        title: this.title,
                        description: this.message,
                        category: "technical",
                        priority: "medium",
                        source: "manual"
                    }
                    axios.post(BaseURL + "api/chat_app/tickets/tickets/", data).then((res) => {
                        toast.success("Request processed successfully.");
                        this.closePopupOfTicketCreationMethod();
                        this.submitted = false;
                    }).catch((err) => {
                        toast.error(err.data[0] || err.data || err.data.msg);
                        this.submitted = false;
                    })
                }
            })
        },
        closePopupOfTicketCreationMethod() {
            bus.$emit('botTicketsPopupBus', false);
            document.body.classList.remove('body_right_scroll_remove');
        }
    }
}
</script>

<style lang="scss" scoped>
.meeting_popup_scroll {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 1000;
    background: rgba(0, 0, 0, 0.92);
    height: 100dvh;
    overflow-y: auto;

    .create_ticket_popup {
        display: table;
        width: 100%;
        height: 100%;
        font-family: 'MyriadProRegular', 'Lato', sans-serif;

        @media only screen and (max-width:767px) {
            overflow-y: auto;
        }

        .create_ticket_popup_center {
            display: table-cell;
            vertical-align: middle;
        }

        .create_ticket_popup_modal {
            background: #000;
            max-width: 640px;
            margin: 0 auto;
            border-radius: 5px;
            -webkit-box-shadow: 0px 0px 13px rgba(255, 213, 0, 0.6);
            box-shadow: 0px 0px 13px rgba(255, 213, 0, 0.6);
        }

        .create_ticket_popup_close {
            position: absolute;
            top: 15px;
            right: 10px;
            line-height: 1;

            .fa {
                font-size: 20px;
                color: red;
                cursor: pointer;
                transform: scale(1);
                -webkit-transform: scale(1);
                -moz-transform: scale(1);
                -webkit-transition: all ease 0.5s;
                transition: all ease 0.5s;

                &:hover {
                    color: #87cefa;
                }
            }
        }

        .create_ticket_popup_header {
            padding: 15px;
            position: relative;
            border-bottom: 1px solid rgba(255, 255, 255, 0.2);
            color: #ffffff;

            h4 {
                font-size: 24px;
                letter-spacing: 0;
                margin-bottom: 0;
            }
        }

        .create_ticket_popup_body {
            padding: 15px;

            label {
                font-size: 16px;
                margin-bottom: 4px;
            }

            .form-control {
                height: auto;
                padding: 7px 15px;
                background: rgba(255, 255, 255, 0.1);
                border-color: transparent;
                font-size: 16px;
                color: #ffffff;
                font-family: 'MyriadProRegular', 'Lato', sans-serif;
                -webkit-transition: all 0.7s cubic-bezier(0.42, 1.14, 1, 1);
                transition: all 0.7s cubic-bezier(0.42, 1.14, 1, 1);
            }

            .invalid-feedback {
                font-size: 14px;
                line-height: 1;
            }
        }

        /* Toggle button styles */
        .btn-primary {
            cursor: pointer;
            position: relative;
            min-width: 95px;
            -webkit-box-shadow: none !important;
            box-shadow: none !important;
            outline: none !important;
            background: rgba(255, 255, 255, 0.12) !important;
            color: #ffffff !important;
            border: none;
            border-radius: 3px;
            font-family: 'MyriadProRegular', 'Lato', sans-serif;
            font-size: 18px;

            &:hover {
                background: #87cefa !important;
                color: #000 !important;
                border-color: #87cefa !important;
            }
        }

    }
}
</style>